import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
  const isExists = document.querySelector('.read-more__slider');

  if (isExists) {
    var splide = new Splide('.read-more__slider', {
      gap: 24,
      pagination: false,
      arrows: true,
      fixedHeight: 98,
      autoWidth: true,
      breakpoints: {
        768: {
          arrows: false,
        }
      }
    });

    splide.mount();
  }
});